import { render, staticRenderFns } from "./ChatUser.CarouselItem.vue?vue&type=template&id=081bec8a&scoped=true&"
import script from "./ChatUser.CarouselItem.vue?vue&type=script&lang=js&"
export * from "./ChatUser.CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatUser.CarouselItem.vue?vue&type=style&index=0&id=081bec8a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bec8a",
  null
  
)

export default component.exports